import instance from '../api';
import {
  CustomViewData,
  CustomViewServiceResponse,
  GetCustomViewApiResponse,
  PreviewResult,
  PreviewResultResponse,
  UpdateCustomViewApiResponse,
  UpdateCustomViewData,
} from '../../components/well-edit-view/WellEditViewData';

export const getCustomView = async (wellGroupName: string): Promise<CustomViewServiceResponse<CustomViewData>> => {
  try {
    const endpoint = `/Lookup/GroupStatusViews/GetCustomView/${wellGroupName}`;
    const response = await instance.get<GetCustomViewApiResponse>(endpoint);

    if (response.data.result?.status && response.data.values && response.data.values.length > 0) {
      const customView = response.data.values[0];
      const customViewData: CustomViewData = {
        wellGroupName: customView.groupName || '',
        parentGroupName: customView.parentGroupName || '',
        previewText: customView.sqlText || '',
        filterGroup: customView.filterGroup || false,
        hidden: customView.hidden || false,
        scoreValue: customView.scoreValue,
        priority: customView.priority,
      };

      return {
        success: true,
        data: customViewData,
      };
    } else {
      return {
        success: false,
        error: 'No custom view data found or API returned unsuccessful status',
      };
    }
  } catch (error: any) {
    console.error('Error fetching custom view:', error);

    return {
      success: false,
      error: error?.response?.data?.message || error?.message || 'Failed to fetch custom view',
    };
  }
};

export const updateCustomView = async (
  originalGroupName: string,
  updateData: UpdateCustomViewData,
): Promise<CustomViewServiceResponse> => {
  try {
    const endpoint = `/Lookup/GroupStatusViews/UpdateCustomView?originalGroupName=${encodeURIComponent(originalGroupName)}`;
    const response = await instance.put<UpdateCustomViewApiResponse>(endpoint, updateData);

    if (response.data.result?.status) {
      return {
        success: true,
      };
    } else {
      return {
        success: false,
        error: response.data.result?.value || 'Update failed',
      };
    }
  } catch (error: any) {
    return {
      success: false,
      error: error?.response?.data?.message || error?.message || 'Failed to update custom view',
    };
  }
};

export const createCustomView = async (updateData: UpdateCustomViewData): Promise<CustomViewServiceResponse> => {
  try {
    const endpoint = `/Lookup/GroupStatusViews/CreateCustomView`;
    const response = await instance.post<UpdateCustomViewApiResponse>(endpoint, updateData);

    if (response.data.result?.status) {
      return {
        success: true,
      };
    } else {
      return {
        success: false,
        error: response.data.result?.value || 'Creation failed',
      };
    }
  } catch (error: any) {
    return {
      success: false,
      error: error?.response?.data?.message || error?.message || 'Failed to create custom view',
    };
  }
};

export const executeCustomViewPreview = async (
  previewText: string,
): Promise<{ success: boolean; data?: PreviewResult[]; error?: string }> => {
  try {
    const endpoint = `/Lookup/GroupStatusViews/CustomViewPreview`;
    const response = await instance.post<PreviewResultResponse>(endpoint, { previewText });
    if (response.data.result?.status) {
      return {
        success: true,
        data: response.data.data,
      };
    } else {
      return {
        success: false,
        error: response.data.result?.value || 'Failed to execute preview query',
      };
    }
  } catch (error: any) {
    return {
      success: false,
      error: error?.response?.result?.value || 'Failed to execute preview query',
    };
  }
};
